import docReady from '../../../assets/js/docReady';

class TaxCalculator {
    constructor(element) {
        this.calculatorTool = element;
        this.electricityInput = element.querySelector('#electricity-usage');
        this.gasInput = element.querySelector('#gas-usage');
        this.calculateButton = element.querySelector('#button-tax-check');
        this.resultsContainer = element.querySelector('.tax-calculator-results-container');

        this.attachEventListeners();
    }

    attachEventListeners() {
        this.calculateButton.addEventListener('click', () => this.calculate());
    }

    calculate() {
        const electricityUsage = parseFloat(this.electricityInput.value);
        const gasValue = this.gasInput.value.trim();
        const gasUsage = parseFloat(gasValue) || 0;

        const error = this.calculatorTool.querySelector('[data-error-field="electricity-usage"]');
        error.textContent = '';
        this.electricityInput.classList.remove('has-error');

        const gasError = this.calculatorTool.querySelector('[data-error-field="gas-usage"]');
        gasError.textContent = '';
        this.gasInput.classList.remove('has-error');

        if (this.electricityInput.value.trim() === '') {
            error.textContent = 'Voer je stroomverbruik in.';
            this.electricityInput.classList.add('has-error');
            this.resultsContainer.classList.remove('visible');
            return;
        }
        
        if (gasUsage > 170000) {
            gasError.textContent = 'Maximaal 170.000 m³.';
            this.gasInput.classList.add('has-error');
            this.resultsContainer.classList.remove('visible');
            return;
        }


        const vat_percentage = 0.21;

        const rates = {
            2024: {
                electricity: [
                    { max: 2900, rate: 0.10880 },
                    { max: 10000, rate: 0.10880 },
                    { max: 50000, rate: 0.09037 },
                    { max: 10000000, rate: 0.03943 },
                    { max: Infinity, rate: 0.00254 }
                ],
                gas: [
                    { max: 1000, rate: 0.58301 },
                    { max: 170000, rate: 0.58301 },
                    { max: 1000000, rate: 0.22378 },
                    { max: 10000000, rate: 0.12855 },
                    { max: Infinity, rate: 0.04886 }
                ],
                discount: 631.39
            },
            2025: {
                electricity: [
                    { max: 2900, rate: 0.10154 },
                    { max: 10000, rate: 0.10154 },
                    { max: 50000, rate: 0.06937 },
                    { max: 10000000, rate: 0.03868 },
                    { max: Infinity, rate: 0.00388 }
                ],
                gas: [
                    { max: 1000, rate: 0.57816 },
                    { max: 170000, rate: 0.57816 },
                    { max: 1000000, rate: 0.31573 },
                    { max: 10000000, rate: 0.20347 },
                    { max: Infinity, rate: 0.05385 }
                ],
                discount: 635.19
            }
        };

        const currentYear = new Date().getFullYear();
        const previousYear = currentYear - 1;

        const calcTax = (usage, tiers) => {
            let remaining = usage;
            let totalExcl = 0;
            let previousMax = 0;
            const breakdown = [];

            for (const tier of tiers) {
                if (remaining <= 0) break;

                const tierRange = tier.max - previousMax;
                const tierAmount = Math.min(remaining, tierRange);
                const tierCost = tierAmount * tier.rate;

                breakdown.push({
                    from: previousMax + 1,
                    to: tier.max,
                    used: tierAmount,
                    rate: tier.rate,
                    cost: tierCost
                });

                totalExcl += tierCost;
                remaining -= tierAmount;
                previousMax = tier.max;
            }

            const vat = totalExcl * vat_percentage;
            const totalIncl = totalExcl + vat;

            return { totalExcl, vat, totalIncl, breakdown };
        };

        const calcYear = (year) => {
            const electricity = calcTax(electricityUsage, rates[year].electricity);
            const gas = gasUsage ? calcTax(gasUsage, rates[year].gas) : { totalExcl: 0, vat: 0, totalIncl: 0, breakdown: [] };
            const discount = rates[year].discount;

            const vat = electricity.vat + gas.vat;
            const totalIncl = electricity.totalIncl + gas.totalIncl;
            const total = totalIncl - discount;

            return { electricity, gas, discount, vat, totalIncl, total };
        };

        const renderBreakdown = (container, breakdown) => {
            const tbody = container.querySelector('tbody');
            if (!tbody) return;
        
            tbody.innerHTML = '';
        
            breakdown.forEach((tier) => {
                const from = tier.from.toLocaleString('nl-NL');
                const to = tier.to === Infinity ? '∞' : tier.to.toLocaleString('nl-NL');
                const range = `${from} t/m ${to} kWh`;
        
                const costInclVAT = tier.cost * 1.21;
        
                const tr = document.createElement('tr');
                tr.innerHTML = `
                    <td>${range}</td>
                    <td>€ ${costInclVAT.toFixed(2).replace('.', ',')}</td>
                `;
                tbody.appendChild(tr);
            });
        };
        

        const updateDOM = (container, result) => {
            const electricityTiers = container.querySelector('.electricity-tiers');
            const gasTiers = container.querySelector('.gas-tiers');
            const discountEl = container.querySelector('.discount-amount');
            const totalEl = container.querySelector('.total-amount');
            const totalElectricityEl = container.querySelector('.total-amount-electricity');

            renderBreakdown(electricityTiers, result.electricity.breakdown);

            if (totalElectricityEl) {
                totalElectricityEl.textContent = `€ ${result.electricity.totalIncl.toFixed(2).replace('.', ',')}`;
            }

            gasTiers.innerHTML = `€ ${result.gas.totalIncl.toFixed(2).replace('.', ',')}`;

            const gasBreakdownEl = container.querySelector('.item.gas-breakdown');
            if (gasBreakdownEl) {
                gasBreakdownEl.style.display = result.gas.totalIncl > 0 ? 'flex' : 'none';
            }

            discountEl.textContent = `- € ${result.discount.toFixed(2).replace('.', ',')}`;
            const totalFormatted = `${result.total < 0 ? '-' : ''}€ ${Math.abs(result.total).toFixed(2).replace('.', ',')}`;
            totalEl.textContent = totalFormatted;
            
            let vatEl = container.querySelector('.vat-amount');
            if (!vatEl) {
                vatEl = document.createElement('div');
                vatEl.classList.add('vat-amount');
                vatEl.innerHTML = `<span>Waarvan btw:</span> <span class="vat-value value"></span>`;
                totalEl.parentElement.insertAdjacentElement('afterend', vatEl);
            }

            vatEl.querySelector('.vat-value').textContent = `€ ${result.vat.toFixed(2).replace('.', ',')}`;
        };

        const thisYearContainer = this.resultsContainer.querySelector('.this-year');
        const lastYearContainer = this.resultsContainer.querySelector('.last-year');

        const resultCurrent = calcYear(currentYear);
        const resultPrevious = calcYear(previousYear);

        updateDOM(thisYearContainer, resultCurrent);
        updateDOM(lastYearContainer, resultPrevious);

        const resultIntro = this.resultsContainer.querySelector('.result-intro');
        const isNegative = resultCurrent.total < 0;
        const formattedTotal = `€ ${Math.abs(resultCurrent.total).toFixed(2).replace('.', ',')}`;
        const rawDifference = resultCurrent.total - resultPrevious.total;
        const formattedDifference = Math.abs(rawDifference).toFixed(2).replace('.', ',');
        const differenceType = isNegative
            ? rawDifference < 0 ? 'meer' : 'minder'
            : rawDifference > 0 ? 'meer' : 'minder';
        
        if (isNegative) {
            resultIntro.innerHTML = `
                <span class="header">Energiebelasting in ${currentYear}</span>
                Je energiebelasting is lager dan de belastingvermindering. Dit jaar krijg je <span class="value">${formattedTotal}</span> terug.
                Dat is <span class="year-difference value ${differenceType}">€ ${formattedDifference} ${differenceType}</span> ten opzichte van ${previousYear}.
            `;
            resultIntro.classList.add('is-negative');
        } else {
            resultIntro.innerHTML = `
                <span class="header">Energiebelasting in ${currentYear}</span>
                Dit jaar betaal je <strong>${formattedTotal}</strong> aan energiebelasting, inclusief btw en belastingvermindering.
                Dat is <span class="year-difference value ${differenceType}">€ ${formattedDifference} ${differenceType}</span> ten opzichte van ${previousYear}.
            `;
            resultIntro.classList.remove('is-negative');
        }        

        this.resultsContainer.classList.add('visible');
    }
}

docReady(() => {
    document.querySelectorAll('.tax-calculator-component').forEach((element) => {
        new TaxCalculator(element);
    });
});
